const Intro = () => {
  return (
    <div className="css-typing fixed">
      <div>
        <p>
          <span>{"<"}</span>Akash<span>{"/>"}</span>
        </p>
        <p>
          <span>{"<"}</span>Rattan<span>{"/>"}</span>
        </p>
      </div>
    </div>
  );
};

export default Intro;
